import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MercadoPagoService } from '../../services/mercado-pago.service';
import { loadMercadoPago } from '@mercadopago/sdk-js';

@Component({
  selector: 'app-btn-wallet',
  standalone: true,
  imports: [],
  templateUrl: './btn-wallet.component.html',
  styleUrl: './btn-wallet.component.scss'
})
export class BtnWalletComponent implements OnInit, OnDestroy {
  @Input() idPayment: string = ''

  private walletOpenHandler: any;
  private walletCloseHandler: any;
  private walletSuccessHandler: any;
  private walletErrorHandler: any;

  constructor(private mpService: MercadoPagoService) { }

  async ngOnInit() {
    console.log('entro aca... ', this.idPayment)
    await loadMercadoPago();
    localStorage.setItem('idPago', this.idPayment);
    this.insertFileJS();
    this.setupWalletListeners();
    // });
  }

  insertFileJS():void{
    let fileJS = document.createElement("script");
		fileJS.setAttribute("id", 'wallet');
		fileJS.setAttribute("src", '../../assets/js/btnMP.js');
		document.head.appendChild(fileJS);
    console.log('paso')
  }
  private setupWalletListeners(): void {
    // Evento cuando el modal se abre
    this.walletOpenHandler = () => {
      console.log('**Modal de Mercado Pago abierto');
      // Aquí puedes ejecutar lógica cuando se abre el modal
    };

    // Evento cuando el modal se cierra
    this.walletCloseHandler = () => {
      console.log('**Modal de Mercado Pago cerrado');
      // Aquí puedes ejecutar lógica cuando se cierra el modal
    };

    // Evento cuando el pago es exitoso
    this.walletSuccessHandler = (event: any) => {
      console.log('Pago exitoso:', event.detail);
      // Aquí maneja el pago exitoso
    };

    // Evento cuando hay error
    this.walletErrorHandler = (event: any) => {
      console.log('Error en el pago:', event.detail);
      // Aquí maneja los errores
    };

    // Agregar listeners
    document.addEventListener('wallet:open', this.walletOpenHandler);
    document.addEventListener('wallet:close', this.walletCloseHandler);
    document.addEventListener('wallet:success', this.walletSuccessHandler);
    document.addEventListener('wallet:error', this.walletErrorHandler);
  }

  ngOnDestroy(): void {
    // Limpiar todos los listeners cuando el componente se destruye
    if (this.walletOpenHandler) {
      document.removeEventListener('wallet:open', this.walletOpenHandler);
    }
    if (this.walletCloseHandler) {
      document.removeEventListener('wallet:close', this.walletCloseHandler);
    }
    if (this.walletSuccessHandler) {
      document.removeEventListener('wallet:success', this.walletSuccessHandler);
    }
    if (this.walletErrorHandler) {
      document.removeEventListener('wallet:error', this.walletErrorHandler);
    }

    // Remover el script inyectado
    const walletScript = document.getElementById('wallet');
    if (walletScript) {
      walletScript.remove();
    }
  }
  
}
